module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Search Index Settings\n          "), _c('button', {
    staticClass: "pull-right btn btn-sm btn-danger delete-index-all",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": _vm.deleteIndexForAll
    }
  }, [_vm._v("\n            Delete index for all type\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-sm btn-success update-index-all",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": _vm.updateIndexForAll
    }
  }, [_vm._v("\n            Create index for all type\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "pull-right btn btn-sm btn-primary reload-source",
    on: {
      "click": _vm.reloadSource
    }
  }, [_vm._v("\n            Update index data\n            "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.types), function(item) {
    return _c('tr', {
      key: item.type,
      attrs: {
        "data-type": item.type
      }
    }, [_c('td', [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.documents_count))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          return _vm.updateIndexForType(item.type)
        }
      }
    }, [_vm._v("\n                      Update index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.deleteIndexForType(item.type)
        }
      }
    }, [_vm._v("\n                      Delete index\n                      "), _c('span', {
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])])])
  }), 0)])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Count")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64c2e090","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Search.vue
// module id = 928
// module chunks = 0